import Catalog from '@/creditflowresearch/ui/components/staticPages/Catalog';
import getServerSideSponsorsCatalog
  from '@/creditflowresearch/application/Catalog/Sponsors/serverSide/getServerSideSponsorsCatalog';
import { CatalogSponsorsProvider } from '@/creditflowresearch/application/Catalog/Sponsors/SponsorsCatalogContext';
import ICatalogCollection from '@/creditflowresearch/application/Catalog/common';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const serverSponsorsCatalog: ICatalogCollection = await getServerSideSponsorsCatalog(context);
  return {
    props: {
      serverSponsorsCatalog,
    },
  };
}, { needsLegacyDictionaries: false });

const ListOfGlobalFixedIncomeCorporateSponsors = ({ serverSponsorsCatalog }: ICatalogCollection) => (
  <CatalogSponsorsProvider sponsors={ serverSponsorsCatalog }>
    <Catalog />
  </CatalogSponsorsProvider>
);

export default ListOfGlobalFixedIncomeCorporateSponsors;
